import { render, staticRenderFns } from "./CsvCost.vue?vue&type=template&id=023af09a&scoped=true&lang=pug&"
import script from "./scripts/CsvCost.js?vue&type=script&lang=js&"
export * from "./scripts/CsvCost.js?vue&type=script&lang=js&"
import style0 from "./CsvCost.vue?vue&type=style&index=0&id=023af09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023af09a",
  null
  
)

export default component.exports